import HARDCODE from "../../business-const/HardCode/HardCode"

import LABEL from "../../business-const/Label/Label"



const tipoMomentoTributacaoIRList = [
    {
        id: HARDCODE.tipoMomentoTributacaoIRIsento,
        descricao: 'Isento',
        ordem: 10,
    },
    {
        id: HARDCODE.tipoMomentoTributacaoIRComeCotas,
        descricao: 'Come-Cotas',
        ordem: 20,
    },
    {
        id: HARDCODE.tipoMomentoTributacaoIRPGBL,
        descricao: 'PGBL',
        ordem: 30,
    },
    {
        id: HARDCODE.tipoMomentoTributacaoIRVGBL,
        descricao: 'VGBL',
        ordem: 40,
    },
    {
        id: HARDCODE.tipoMomentoTributacaoIRResgate,
        descricao: 'Resgate',
        ordem: 50,
    },
    {
        id: '',
        descricao: LABEL.naoInformar,
        ordem: 60,
    },
]

export default tipoMomentoTributacaoIRList